export default __webpack_public_path__ + "static/media/section-tr.c913b6cf.png";